export class ConstantContactEmailAddressPost {

    constructor(
        public address: string,
        public permissionToSend: string | null
    ){}
}
